<script setup>
import { ref, computed, onMounted } from 'vue'
import Pagination from '@/components/Pagination/Pagination.vue'


const props = defineProps({
	total: {
		type: Number,
		default: 0
	},
	
	columns: {
		type: Number,
		default: 3
	},
	
	rowGap: {
		type: Number,
		default: 30
	},
	
	columnGap: {
		type: Number,
		default: 30
	},
	
	width: {
		type: String,
		default: '1fr'
	},
	
	pageSize: {
		type: Number,
		default: 6
	}
})

const emits = defineEmits(['pageChange'])

const windowWidth = ref(1920)

const listContentStyle = computed(() => {
	return {
		'grid-column-gap': `${props.columnGap}px`,
		'grid-row-gap': `${props.rowGap}px`,
		'grid-template-columns': `repeat(${props.columns}, ${props.width})`
	}
})

const pagerCount = computed(() => {
	return windowWidth.value > 1024 ? 7 : 5
})

const handlePageChange = (currentPage, pageSize) => {
	emits("pageChange", { page: currentPage, size: pageSize })
}

function handleResize() {
	windowWidth.value = window.innerWidth;
}
const getWindowInfo = () => {
	window.addEventListener('resize', () => handleResize());
}

onMounted(() => {
	windowWidth.value = window.innerWidth;
	getWindowInfo()
})


</script>

<template>
	<div class="list">
		<div class="list__content" :style="[ listContentStyle ]">
			<slot />
		</div>
		
		<div class="list__pagination" v-if="total">
			<Pagination
				background
				layout="prev, pager, next"
				:total="total"
				:default-page-size="pageSize"
				:pagerCount="pagerCount"
				@change="handlePageChange"
			/>
		</div>
	</div>
</template>

<style scoped lang="less">
.list {
	
	&__content {
		display: grid;
		//grid-template-columns: repeat(3, 1fr);
		//grid-template-rows: repeat(2, 1fr);
		//gap: 30px;
	}
	
	
	&__pagination {
		display: flex;
		justify-content: center;
		margin-top: 30px;
	}
}

@media only screen and (max-width: 768px) {
	.list {
		
		
		&__pagination {
			margin-top: 30px;
		}
	}
}
</style>